import { Salutation } from '../../../../../../../constants'
import { Customer } from '../../../../../../../types'
import { salutationToDisplayText } from '../../../../../../../util'
import { Title } from '../../../../../../Title'

interface Props {
  customer: Customer
}

const CustomerTitle = ({ customer }: Props) => {
  const salutationText = salutationToDisplayText?.[customer?.salutation?.toUpperCase() as Salutation] ?? ''
  const salutation = salutationText ? ` (${salutationText})` : ''

  const customerName =
    customer?.givenName && customer?.familyName ? `${customer?.familyName}, ${customer?.givenName}` : 'Customer Not Found'

  return <Title color="primary" variant="h1">{`${customerName}${salutation}`}</Title>
}

export { CustomerTitle }
